/**
 * Transcendance d'ascension — sink INFINI de points de prestige → +DPS permanent,
 * au-delà des 4 upgrades plafonnés de l'atelier. Coût exponentiel en points, DPS additif.
 *
 * Aligné `server/app/services/ascension_service.ts` (constantes `ASCENSION_TRANSCENDENCE_*`,
 * verrouillé par `ascension_service.spec.ts`). Le bonus DPS est appliqué côté client.
 */
export const ASCENSION_TRANSCENDENCE_DPS_STEP = 0.015
export const ASCENSION_TRANSCENDENCE_MAX_LEVEL = 999
export const ASCENSION_TRANSCENDENCE_COST_BASE = 8
export const ASCENSION_TRANSCENDENCE_COST_GROWTH = 1.15

/**
 * Tier 3 (synergie) : chaque génération Pokédex complétée amplifie le *bonus* DPS de la
 * Transcendance de +1 % (à 9 gens : bonus ×1,09). Actif seulement sous le flag
 * `ascension_synergy_enabled` (sinon `genCount`=0).
 */
export const TRANSCENDENCE_POKEDEX_AMP_PER_GEN = 0.01

/** Coût (points) pour acheter le palier `currentLevel → currentLevel+1`. */
export function getAscensionTranscendenceCost(currentLevel: number): number {
  const lvl = Math.max(0, Math.floor(Number(currentLevel) || 0))
  return Math.ceil(
    ASCENSION_TRANSCENDENCE_COST_BASE * Math.pow(ASCENSION_TRANSCENDENCE_COST_GROWTH, lvl)
  )
}

/**
 * Multiplicateur DPS de la Transcendance au niveau donné. >= 1.
 * `completedGenCount` (Tier 3) amplifie le bonus ; 0 = comportement historique.
 */
export function getAscensionTranscendenceDpsMult(level: number, completedGenCount = 0): number {
  const lvl = Math.max(0, Math.min(ASCENSION_TRANSCENDENCE_MAX_LEVEL, Math.floor(Number(level) || 0)))
  const gens = Math.max(0, Math.floor(Number(completedGenCount) || 0))
  const amp = 1 + gens * TRANSCENDENCE_POKEDEX_AMP_PER_GEN
  return Math.round((1 + lvl * ASCENSION_TRANSCENDENCE_DPS_STEP * amp) * 1000) / 1000
}
